// 네이티브(Capacitor) 전용: 정확한 safe-area 인셋을 읽어 CSS 변수(--safe-area-inset-*)로 주입.
// Android 15+ edge-to-edge 강제 + 일부 WebView(Chromium<140)에서 env(safe-area-inset-*)가 0으로
// 잘못 보고되는 버그를 우회. 웹에서는 즉시 no-op → CSS는 env() 폴백(기존과 100% 동일).
// googleAuth.js와 동일한 가드 + 동적 import 패턴.
import { isNative } from "./platform";

function applyInsets(insets) {
  if (!insets) return;
  const root = document.documentElement;
  ["top", "right", "bottom", "left"].forEach((side) => {
    const v = insets[side];
    if (typeof v === "number" && !Number.isNaN(v)) {
      root.style.setProperty(`--safe-area-inset-${side}`, `${v}px`);
    }
  });
}

// 앱 최상위에서 1회 호출. 실패 시 조용히 무시(env() 폴백 유지).
export async function initSafeArea() {
  try {
    if (!isNative()) return;
    const { SafeArea } = await import("capacitor-plugin-safe-area");
    const res = await SafeArea.getSafeAreaInsets();
    applyInsets(res && res.insets);
    // 화면 회전/시스템바 변경 시 갱신.
    SafeArea.addListener("safeAreaChanged", (data) => {
      applyInsets(data && data.insets);
    });
  } catch (e) {
    // 플러그인 미탑재/미지원 → env() 폴백. (개발용 로그만)
    if (typeof console !== "undefined") console.debug("[SafeArea] init skipped:", e && e.message);
  }
}
